import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function QaRetentionChart(props) {


  useLayoutEffect(() => {
    /* Chart code */
// Create root element
// https://www.amcharts.com/docs/v5/getting-started/#Root_element
let root = am5.Root.new("chartdiv2");

// Set themes
// https://www.amcharts.com/docs/v5/concepts/themes/
root.setThemes([
  am5themes_Animated.new(root)
]);

// Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
let chart = root.container.children.push(
  am5xy.XYChart.new(root, {
    panX: true,
    panY: true,
    wheelX: "panX",
    wheelY: "zoomX"
  })
);

// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
let xAxis = chart.xAxes.push(
  am5xy.CategoryAxis.new(root, {
    categoryField: "name",
    renderer: am5xy.AxisRendererX.new(root, {
      minGridDistance: 50
    }),
    tooltip: am5.Tooltip.new(root, {})
  })
);

xAxis.get("renderer").labels.template.setAll({
    rotation: -45,
    centerY: am5.p50,
    centerX: am5.p100,
    fontSize: 14
  });

let yAxis = chart.yAxes.push(
  am5xy.ValueAxis.new(root, {
    renderer: am5xy.AxisRendererY.new(root, {}),
    // strictMinMax: true,
  })
);

xAxis.get("renderer").grid.template.setAll({
  strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
});
yAxis.get("renderer").grid.template.setAll({
  strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
});

yAxis.children.moveValue(am5.Label.new(root, { text: "Retention Time", rotation: -90, y: am5.p50, centerX: am5.p50 }), 0);
xAxis.children.push(am5.Label.new(root, { text: "Injections", x: am5.p50, centerX: am5.p50 }));

// xAxis.get("renderer").grid.template.set("forceHidden", true);
// yAxis.get("renderer").grid.template.set("forceHidden", true);

// Add series
// https://www.amcharts.com/docs/v5/charts/xy-chart/series/
let series = chart.series.push(
  am5xy.LineSeries.new(root, {
    minBulletDistance: 10,
    xAxis: xAxis,
    yAxis: yAxis,
    valueYField: "value",
    categoryXField: "name",
    tooltip: am5.Tooltip.new(root, {
      pointerOrientation: "horizontal",
      labelText: "{valueY}"
    })
  })
);

series.strokes.template.setAll({
  strokeWidth: 3
});

const formattedData = props.data.map(item => ({
  ...item,
  name: item.name.split('.').slice(0, -1).join('.')
}));

xAxis.data.setAll(formattedData);
series.data.setAll(formattedData);

// series.data.setAll(props.data);
// xAxis.data.setAll(props.data);

series.bullets.push(function () {
  return am5.Bullet.new(root, {
    sprite: am5.Circle.new(root, {
      radius: 9,
      fill: series.get("fill"),
      stroke: root.interfaceColors.get("background"),
      strokeWidth: 2
    })
  });
});

// Add cursor
// https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
  xAxis: xAxis
}));
cursor.lineY.set("visible", false);


// Make stuff animate on load
// https://www.amcharts.com/docs/v5/concepts/animations/
series.appear(1000, 100);
chart.appear(1000, 100);

// **Calculate Average**
const sum = props.data.reduce((acc, item) => acc + item.value, 0);
const average = sum / props.data.length;


// Define 2s Range 
const range = 2 / 60; // 2 seconds in minutes = 0.0333
const lowerLimit = average - range;
const upperLimit = average + range;

// **Find Min & Max from Data + Limits**
const dataMin = Math.min(...props.data.map(d => d.value)); // Smallest data value
const dataMax = Math.max(...props.data.map(d => d.value)); // Largest data value

// **Set Y-Axis Min & Max Dynamically**
const yAxisMin = Math.min(dataMin, lowerLimit) - 0.01; // Expand slightly
const yAxisMax = Math.max(dataMax, upperLimit) + 0.01; // Expand slightly

yAxis.set("min", yAxisMin);
yAxis.set("max", yAxisMax);

// **Add Limits**
addLimits(lowerLimit, upperLimit , average);




// Function to add process control ranges
function addLimits(lower, upper, avg) {
  // Add range fill
  createRange(lower, upper, undefined, am5.color(0xffce00));
  
  // Add upper/average/lower lines
  createRange(lower, undefined, "-2s", am5.color(0x4d00ff));
  createRange(upper, undefined, "+2s", am5.color(0x4d00ff));
  createRange(avg, undefined, "Average", am5.color(0x4d00ff), true);
  
}


function createRange(value, endValue, label, color, dashed) {
  let rangeDataItem = yAxis.makeDataItem({
    value: value,
    endValue: endValue
  });
  
  let range = yAxis.createAxisRange(rangeDataItem);
  
  if (endValue) {
    range.get("axisFill").setAll({
      fill: color,
      fillOpacity: 0.2,
      visible: true
    });
  }
  else {
    range.get("grid").setAll({
      stroke: color,
      strokeOpacity: 1,
      strokeWidth: 2,
      location: 1
    });
    
    if (dashed) {
      range.get("grid").set("strokeDasharray", [5, 3]);
    }
  }

  if (label) {
    range.get("label").setAll({
      text: label,
      location: 1,
      fontSize: 19,
      inside: true,
      centerX: am5.p0,
      centerY: am5.p100,
    });
  }
}


    return () => {
        root.dispose();
    };
        });
  
  
    return (
      <>
        <div id="chartdiv2" style={{width:'100%', height: '100%'}}></div>
      </>
    );
  }
  export default QaRetentionChart;